export enum SchedulerReoccurrence {
  Manually = -10,
  Once = 0,
  Reoccurring = 10
}
